import { call, all, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import service from 'commons/services/notifications';
import { actions as NotificationsActions, types as NotificationsTypes } from './actions';

export function* loadNotifications({ page, search }) {
	try {
		yield put(NotificationsActions.updateShowPreloader(true));
		const response = yield call(service.getNotificacaoPaginadoUsuario, page - 1, 10, search);

		yield call(delay, 1000);
		yield put(NotificationsActions.setNotifications(response.data));
	} catch (error) {
		const { message } = error.response.data;
		// eslint-disable-next-line
		yield put(NotificationsActions.updateShowPreloader(false));
		console.log('message error: ', message);
	} finally {
		yield put(NotificationsActions.updateShowPreloader(false));
	}
}

export function* updateNotificationsStatus({ news }) {
	try {
		news
			? yield call(service.updateStatusNotificationsById, news)
			: yield call(service.updateAllStatusNotifications);
	} catch (error) {
		const { message } = error.response.data;
		// eslint-disable-next-line
		console.log('message error: ', message);
	}
}

export default function* root() {
	yield all([
		takeLatest(NotificationsTypes.GET_NOTIFICATIONS, loadNotifications),
		takeLatest(NotificationsTypes.UPDATE_NOTIFICATION_STATUS, updateNotificationsStatus)
	]);
}
